"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SliderStyle = {
    baseStyle: {
        thumb: {
            backgroundColor: 'primary.400',
        },
        filledTrack: {
            backgroundColor: 'gray.400',
        },
    },
};
exports.default = SliderStyle;
